import { AppContext, DefaultAppContext } from './AppContext';

const localStorageInfoKey = 'rituals.appContext';

export type LocalStorageAppContext = {
  email: string;
  authenticationToken?: string;
  userToken?: string;
  country?: string;
  language?: string;
  currencyID?: string;
  locale?: string;
  endpointKey?: string;
};

export const DefaultLocalStorageAppContext: LocalStorageAppContext = {
  email: ''
};

const AppContextUtil = {
  saveToLocalStorage: (appContext: AppContext) => {
    const localStorageAppContext: LocalStorageAppContext = {
      email: appContext.email,
      authenticationToken: appContext.authenticationToken,
      userToken: appContext.userToken,
      country: appContext.country,
      currencyID: appContext.currencyID,
      language: appContext.language,
      locale: appContext.locale,
      endpointKey: appContext.endpointKey,
    };

    localStorage.setItem(
      localStorageInfoKey,
      JSON.stringify(localStorageAppContext)
    );
  },

  getFromLocalStorage: (countryId?: string): AppContext => {
    let appContext: AppContext = DefaultAppContext;
    const localStorageData = localStorage.getItem(localStorageInfoKey);

    if (localStorageData) {
      const localStorageAppContext: LocalStorageAppContext = JSON.parse(
        localStorageData
      );

      appContext = { ...appContext, ...localStorageAppContext };
    }

    return appContext;
  }
};

export default AppContextUtil;
